import React, { Component } from 'react';
import QuickSearchResult from './QuickSearchResult';
import { translate } from '../Services/translation';
import Svg from '../Components/Svg';

class QuickSearch extends Component {
    focusOnInput() {
        setTimeout(() => {
            this.searchInput && this.searchInput.focus();
        }, 0);
    }

    render() {
        const {
            query,
            result,
            showResult,
            showFullForm,
            onSearch,
            onBlur,
            onKeyDown,
            clearSearchQuery,
            toggleShowFullForm,
            selectedItem,
            searchUrl,
            isMuurikka,
            isLoading,
            lastClickedNodeRef
        } = this.props;

        return (
            <>
                <div
                    className={`quick-search quick-search__result-wrapper ${showFullForm ? 'show' : ''} ${isMuurikka ? 'muurikka' : ''}`} role="search">
                    <div className="quick-search__inner-container">
                        <div className="quick-search__form-row">
                            <div className="quick-search__form">
                                <input
                                    className="quick-search__input"
                                    type="text"
                                    placeholder={translate('general.search')}
                                    autoComplete="off"
                                    value={query}
                                    onChange={event => onSearch(event.target.value)}
                                    onKeyDown={event => onKeyDown(event, {searchUrl})}
                                    ref={(input) => {
                                        this.searchInput = input;
                                    }}
                                    tabIndex={showFullForm ? 0 : -1}
                                    onBlur={() => onBlur()}
                                    onFocus={(e) => lastClickedNodeRef.current = e.target}
                                />

                                {isLoading && 
                                    <div className="quick-search__loading"></div>
                                }

                                {query !== '' && 
                                    <div className="quick-search__clear" onClick={() => clearSearchQuery()} tabIndex={0}></div>
                                }
                            </div>

                            {query !== '' && showResult && 
                                <a href={searchUrl} className="quick-search__submit-button" type="submit">
                                    <span
                                        className="quick-search__submit-title">{translate('general.search.showallresults')}</span>
                                </a>
                            }
                        </div>

                        {query !== '' && showResult &&
                            <QuickSearchResult result={result} selectedItem={selectedItem} searchUrl={searchUrl} isMuurikka={isMuurikka}/>}
                    </div>
                </div>

                <div
                    className={`quick-search__trigger`}
                    title="show quick search"
                    role="button"
                    tabIndex={0}
                    aria-label={translate('general.search')}
                    onClick={e => {
                        e.preventDefault();
                        toggleShowFullForm();
                        this.focusOnInput();
                    }}
                    onKeyDown={e => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            toggleShowFullForm();
                            this.focusOnInput();
                        }
                    }}
                >
                    <Svg icon={showFullForm ? 'close' : 'search'} aria-label={translate('general.search')} />
                </div>
            </>
        )
    }
}

export default QuickSearch;
